export enum AsyncProcessType {
  closing = 'closing',
  lettering = 'lettering',
  unlettering = 'unlettering'
}
